import { combineReducers } from 'redux';
import appReducer from './App/store';
import { createReducer, createPreviewReducer } from './components/pages/CreatePage/store';
import planReducer from './components/pages/PlanPage/store';
import videoReducer from './components/pages/VideosPage/store';
import accountReducer from './components/pages/AccountPage/store';
import exportsReducer from './components/pages/ExportsPage/store';
import mediaPickerReducer from './components/pages/CreatePage/MediaPickers/store';
import userInfoReducer from './components/pages/Admin/UserInfoPage/store';
import billingPageReducer from './components/pages/Admin/BillingPage/store';
import usersPageReducer from './components/pages/Admin/UsersPage/store';
import presetsPageReducer from './components/pages/Admin/PresetsPage/store';
import exportsQueuePageReducer from './components/pages/Admin/ExportsQueuePage/store';
import { connectRouter } from "connected-react-router";
import { history } from './App/history';

const rootReducer = combineReducers({
    app: appReducer,
    create: createReducer,
    createPreview: createPreviewReducer,
    plan: planReducer,
    video: videoReducer,
    account: accountReducer,
    exports: exportsReducer,
    mediaPicker: mediaPickerReducer,
    userInfo: userInfoReducer,
    billingPage: billingPageReducer,
    usersPage: usersPageReducer,
    presetsPage: presetsPageReducer,
    exportsQueuePage: exportsQueuePageReducer,
    router: connectRouter(history)
});

export default rootReducer;